import React from 'react';
import "./Footer.css";

const Footer = () => {
  return (
    <div id='footer'>
        <p>©2024 The Guitarologist | Website designed and maintained by <a href='https://alcantaradevelopment.com/' target='_blank' id='footerLink'>Alcantara Development</a></p>
    </div>
  )
}

export default Footer